import { Navbar } from 'components';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AboutScreen, Landing, ProductDetails } from 'screens';
import { ContactScreen } from 'screens/ContactScreen/ContactScreen';
import { Footer } from 'screens/Footer';

function App() {
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [navbarHidden, setNavbarHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isScrollingDown =
        prevScrollPos < currentScrollPos && currentScrollPos > 50;

      setNavbarHidden(isScrollingDown);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  return (
    <Router>
      <Navbar hidden={navbarHidden} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/product-details/:type/:title"
          element={<ProductDetails />}
        />
        <Route path="/about" element={<AboutScreen />} />
        <Route path="/contact" element={<ContactScreen />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
